"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProdFlowClient = void 0;
const logger_1 = require("@madbox/logger");
const api_client_1 = require("@madbox/api_client");
class ProdFlowClient extends api_client_1.ApiClient {
    constructor() {
        super(...arguments);
        // Methods
        this.AppStatus = {
            create: (entity_id, name, color, order, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'org-admin', 'app_status/create', { name, color, order }, auth);
                return response.app_status;
            }),
            getAll: (entity_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'app_status/get/all', {}, auth);
                return response.app_statuses;
            })
        };
        this.AppVersion = {
            create: (entity_id, version_number, platform, optionalsParams, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'app_version/create', Object.assign({ version_number, platform }, optionalsParams), auth);
                return response.app_version;
            }),
            createWithForecast: (entity_id, name, studio_location_id, version_number, platform, optionalsParams, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'org-admin', 'app_version/create_with_forecast', Object.assign({ name, studio_location_id, version_number, platform }, optionalsParams), auth);
                return response.app_version;
            }),
            createSlackMessage: (entity_id, version_number, platform, optionalsParams, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entity_id, 'app-admin', 'app_version/create/slack_message', Object.assign({ version_number, platform }, optionalsParams), auth);
            }),
            linkForecastToRealProject: (entity_id, new_project_entity_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'application/forecast/link', { new_project_entity_id }, auth);
                return response.application_with_apps_versions;
            }),
            updateVersionNumber: (entity_id, app_version_id, platform, version_number, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', `app_version/${app_version_id}/version_number/update`, { platform, version_number }, auth);
                return response.app_version;
            }),
            resize: (entity_id, app_version_id, start_date, end_date, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'app_version/resize', { app_version_id, start_date, end_date }, auth);
                return response.app_version;
            }),
            delete: (entity_id, app_version_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entity_id, 'app-admin', 'app_version/delete', { app_version_id }, auth);
            }),
            Status: {
                add: (entity_id, app_version_id, app_status_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post(entity_id, 'app-admin', 'app_version/add/status', { app_version_id, app_status_id }, auth);
                    return response.app_version;
                })
            },
            getAllByApps: (entity_id, with_options, start_date, end_date, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'application/get/version', { with_options, start_date, end_date }, auth);
                return response.app_versions;
            }),
            getHomepageAllByApps: (entity_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'application/get/homepage/version', {}, auth);
                return response.app_versions_by_applications;
            }),
            getLastAppVersion: (entity_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'app-admin', 'get/last/version', {}, auth);
                return response.app_version;
            }),
            getNextRelease: (entity_id, startDate, endDate, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'get/next_release', { start_date: startDate, end_date: endDate }, auth);
                return response.next_release;
            }),
        };
        this.Assignee = {
            create: (entity_id, member_id, start_date, end_date, app_version_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'assignee/create', { member_id, start_date, end_date, app_version_id }, auth);
                return response.assignee;
            }),
            update: (entity_id, assignee_id, start_date, end_date, app_version_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'assignee/update', { assignee_id, start_date, end_date, app_version_id }, auth);
                return response.assignee;
            }),
            delete: (entity_id, assignee_id, app_version_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entity_id, 'app-admin', 'assignee/delete', { assignee_id, app_version_id }, auth);
            }),
            getAllByMembers: (entity_id, start_date, end_date, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'member/get/assignee', { start_date, end_date }, auth);
                return response.assignees_by_members;
            })
        };
        this.Milestone = {
            create: (entity_id, app_version_id, title, planned_end_date, effective_end_date, description, ui_type = 0, gcalendar_event, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'milestone/create', { title, description, app_version_id, ui_type, planned_end_date, effective_end_date, gcalendar_event }, auth);
                return response.milestone;
            }),
            update: (entity_id, milestone_id, title, planned_end_date, effective_end_date, ui_type, description, gcalendar_event, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'milestone/update', { milestone_id, title, ui_type, description, planned_end_date, effective_end_date, gcalendar_event }, auth);
                return response.milestone;
            }),
            delete: (entity_id, milestone_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'app-admin', 'milestone/delete', { milestone_id }, auth);
                return response;
            })
        };
        this.MemberFilter = {
            save: (entity_id, member_id, table_filters, assignees_timeline_filters, projects_timeline_filters, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entity_id, 'org-admin', 'member_filter/save', { member_id, table_filters, assignees_timeline_filters, projects_timeline_filters }, auth);
                return response.member_filters;
            }),
            get: (entity_id, member_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get(entity_id, 'org-admin', 'member_filter/get', { member_id }, auth);
                return response.member_filters;
            })
        };
        this.AppVersionCustomTags = {
            getAllCleanedTags: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.get('api', 'admin', 'app_version_custom_tag/get/all/cleaned', {}, auth);
                return response.apps_versions_custom_tags;
            })
        };
    }
    get DEFAULT_API_URL() { return 'https://prod-flow-api.madbox.io'; }
    static get instance() {
        if (!ProdFlowClient._instance) {
            logger_1.Logger.warn('ProdFlowClient hasn\'t been initialized. It will use the default values. ProdFlowClient.init(config) should be called before using it.');
            ProdFlowClient._instance = new ProdFlowClient();
        }
        return ProdFlowClient._instance;
    }
    static init(config = {}) {
        if (ProdFlowClient._instance) {
            logger_1.Logger.warn('ProdFlowClient has already been initialized. Overriding current configuration with the new one.');
            ProdFlowClient.instance.init(config);
        }
        else
            ProdFlowClient._instance = new ProdFlowClient(config);
        return ProdFlowClient.instance;
    }
}
exports.ProdFlowClient = ProdFlowClient;
